import React, { useState, useEffect, useContext, useCallback } from "react";
import { API_URL } from "../../components/api";
import "bootstrap/dist/css/bootstrap.css";
import Axios from "axios";
import AuthContext from "../../context/AuthContext";
import LanguageContext from "../../context/LanguageContext";
import { useHistory } from "react-router-dom";
import Select from "react-select";

function InvoiceOrder(props) {
  const [message, setMessage] = useState(null);
  const [discount, setDiscount] = useState(0);
  const [users, setUsers] = useState([]);
  const [totalWithDiscount, setTotalWithDiscount] = useState(0);
  const [totalWithoutDiscount, setTotalWithoutDiscount] = useState(0);
  const [cat, setCat] = useState([]);
  const [Drawers, setDrawers] = useState([]);
  const [username, setUsername] = useState(0);
  const [note, setNote] = useState("");
  const [description, setDescription] = useState("");
  const [selectedDrawer, setSelectedDrawer] = useState("");
  const [freeItemsDiscount, setFreeItemsDiscount] = useState(0);
  const [hasShift, setHasShift] = useState(true);
  let { user } = useContext(AuthContext);
  const { language, t } = useContext(LanguageContext);
  let authTokens = JSON.parse(localStorage.getItem("authTokens"));
  const history = useHistory();

  useEffect(() => {
    const fetchShift = async () => {
      try {
        const response = await Axios.get(
          `${API_URL}/inventory/shift/status/`,
          {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
            },
            params: { username: user.username },
          }
        );

        if (response.status === 200) {
          setHasShift(Boolean(response.data));
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchShift();
  }, [user.username]);

  const getClient = useCallback(async () => {
    try {
      const response = await Axios.get(
        `${API_URL}/radius/subscriptions/discount/add/`,
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
            "Content-Type": "application/json",
          },
          params: { username: user.username, client_id: props.client_id },
        }
      );
      if (response.status === 200) {
        setUsers(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  }, [authTokens.access, user.username, props.client_id]);

  useEffect(() => {
    let isMounted = true;
    const getOrders = async () => {
      try {
        const response = await Axios.get(
          `${API_URL}/inventory/order/details/`,
          {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
              "Content-Type": "application/json",
            },
            params: {
              username: user.username,
              order_id: props.order_id,
            },
          }
        );
        if (response.status === 200 && isMounted) {
          console.log("API response:", response.data);

          // Calculate total_price for each item if it's not provided
          const itemsWithTotal = response.data.map((item) => {
            const unitPrice =
              item.item_type === "Product"
                ? parseFloat(item.product_selling || 0)
                : parseFloat(item.service_selling || 0);
            const calculatedTotalPrice = item.quantity * unitPrice;
            return {
              ...item,
              total_price: item.total_price || calculatedTotalPrice,
            };
          });

          setCat(itemsWithTotal);
          const initialTotal = calculateTotal(itemsWithTotal);
          const initialFreeItemsDiscount =
            calculateFreeItemsDiscount(itemsWithTotal);
          console.log("Initial total:", initialTotal);
          console.log("Initial free items discount:", initialFreeItemsDiscount);
          setFreeItemsDiscount(initialFreeItemsDiscount);
          setTotalWithoutDiscount(initialTotal);
          setTotalWithDiscount(initialTotal - initialFreeItemsDiscount);
          setDiscount(initialFreeItemsDiscount);
        }
      } catch (error) {
        console.error(error);
      }
    };

    const getDrawers = async () => {
      try {
        const response = await Axios.get(`${API_URL}/inventory/exchange/`, {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: {
            username: user.username,
            include_own: true,
          },
        });
        if (response.status === 200 && isMounted) {
          setDrawers(response.data);
          console.log(response.data);
          const ownResponse = await Axios.get(`${API_URL}/inventory/exchange/`, {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
            },
            params: {
              username: user.username,
              own_drawer: true,
            },
          });
          const ownDrawerId = ownResponse.data && ownResponse.data.drawer_id;
          if (isMounted && response.data.some((drawer) => String(drawer.drawer_id) === String(ownDrawerId))) {
            setSelectedDrawer((current) => current || String(ownDrawerId));
          }
        }
      } catch (error) {
        console.error(error);
      }
    };

    getOrders();
    getDrawers();
    getClient();

    return () => {
      isMounted = false;
    };
  }, [authTokens.access, props.order_id, user.username]);

  const showMessage = (message, type = "success") => {
    setMessage({ text: message, type });
    setTimeout(() => {
      history.push("/accounting/invoice");
    }, 1200);
    setTimeout(() => {
      setMessage(null);
    }, 1000);
  };

  const calculateTotal = (items) =>
    items.reduce((total, item) => {
      // If total_price is provided, use it; otherwise, calculate from unit price and quantity
      const itemTotal = item.total_price
        ? parseFloat(item.total_price)
        : item.quantity *
          (item.item_type === "Product"
            ? parseFloat(item.product_selling || 0)
            : parseFloat(item.service_selling || 0));
      return total + (isNaN(itemTotal) ? 0 : itemTotal);
    }, 0);

  const calculateFreeItemsDiscount = (items) =>
    items.reduce((totalDiscount, item) => {
      if (item.is_free) {
        // If total_price is provided, use it; otherwise, calculate from unit price and quantity
        const itemTotal = item.total_price
          ? parseFloat(item.total_price)
          : item.quantity *
            (item.item_type === "Product"
              ? parseFloat(item.product_selling || 0)
              : parseFloat(item.service_selling || 0));
        return totalDiscount + (isNaN(itemTotal) ? 0 : itemTotal);
      }
      return totalDiscount;
    }, 0);

  const total = calculateTotal(cat);

  const submitData = {
    Action: "Post",
    order: props.order_id,
    total: totalWithoutDiscount,
    discount: discount,
    drawer_id: selectedDrawer,
    sub_id: username,
    note: note,
    description: description,
    userdealer: user.username,
    products: cat
      .filter((item) => item.item_type === "Product")
      .map((product) => ({
        product_id: product.product_id,
        quantity: product.quantity,
      })),
    services: cat
      .filter((item) => item.item_type === "Service")
      .map((service) => ({
        service_id: service.service_id,
        quantity: service.quantity,
      })),
  };

  const userOptions = users.map((item) => ({
    label: item.username,
    value: item.subscription_id,
  }));

  let handleSubmit = async (e) => {
    e.preventDefault();
    Axios.post(`${API_URL}/inventory/invoices/`, submitData, {
      headers: {
        Authorization: `Bearer ${authTokens.access}`,
      },
    })
      .then((response) => {
        console.log(response);
        showMessage(language === "ar" ? t("orderInvoice.creationSuccessful") : "Creation successful!", "success");
      })
      .catch((error) => {
        console.log(error);
        showMessage(language === "ar" ? t("orderInvoice.creationFailed") : "Creation failed!", "danger");
      });
  };

  let handleDiscountChange = (e) => {
    const discountValue = parseFloat(e.target.value);
    // Allow any non-negative number up to the total
    if (
      !isNaN(discountValue) &&
      discountValue >= 0 &&
      discountValue <=
        (Number.isFinite(total) ? total : Number.MAX_SAFE_INTEGER)
    ) {
      setDiscount(discountValue);
      setTotalWithDiscount(Number.isFinite(total) ? total - discountValue : 0);
    }
  };

  const openPriceServices = [
    "Maintenance Fee",
    "Electrical Accessories",
    "Fiber Installation",
    "Labor Fees",
    "IT Support",
    "Fiber Cable",
  ];

  return (
    <div className="testi">
      <div className="mod">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">{language === "ar" ? t("orderInvoice.username") : "Username:"}</label>
            <Select
              id="username"
              className="select-input"
              placeholder={language === "ar" ? t("orderInvoice.chooseUsername") : "Choose Username"}
              options={userOptions}
              onChange={(opt) => setUsername(opt.value)}
              value={userOptions.find((option) => option.value === username)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="drawer">{language === "ar" ? t("orderInvoice.selectDrawerLabel") : "Select Drawer:"}</label>
            <select
              id="drawer"
              className="form-control"
              value={selectedDrawer}
              onChange={(e) => setSelectedDrawer(e.target.value)}
            >
              <option value="">{language === "ar" ? t("orderInvoice.selectDrawer") : "Select Drawer"}</option>
              {Drawers.map((drawerss) => (
                <option key={drawerss.drawer_id} value={drawerss.drawer_id}>
                  {drawerss.drawer_name}
                </option>
              ))}
            </select>
            <div className="row">
              <div className="form-group col-md-6">
                <label htmlFor="invoice-note">{language === "ar" ? t("orderInvoice.note") : "Note:"}</label>
                <input
                  id="invoice-note"
                  className="form-control"
                  type="text"
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                />
              </div>
              <div className="form-group col-md-6">
                <label htmlFor="invoice-description">
                  {language === "ar" ? t("orderInvoice.description") : "Description:"}
                </label>
                <input
                  id="invoice-description"
                  className="form-control"
                  type="text"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>
            </div>
          </div>
          <table className="table">
            <thead>
              <tr>
                <th>{language === "ar" ? t("orderInvoice.itemType") : "Item Type"}</th>
                <th>{language === "ar" ? t("orderInvoice.itemName") : "Item Name"}</th>
                <th>{language === "ar" ? t("orderInvoice.quantity") : "Quantity"}</th>
                <th>{language === "ar" ? t("orderInvoice.unitPrice") : "Unit Price"}</th>
                <th>{language === "ar" ? t("orderInvoice.totalPrice") : "Total Price"}</th>
                <th>{language === "ar" ? t("orderInvoice.isFree") : "Is Free"}</th>
              </tr>
            </thead>
            <tbody>
              {cat.map((item, index) => (
                <tr key={index}>
                  <td>{language === "ar" ? (item.item_type === "Product" ? t("orderInvoice.product") : item.item_type === "Service" ? t("orderInvoice.service") : item.item_type) : item.item_type}</td>
                  <td>
                    {item.item_type === "Product"
                      ? item.product_name
                      : item.service_name}
                  </td>
                  <td>{item.quantity}</td>
                  <td>
                    {item.item_type === "Service" &&
                    openPriceServices.includes(item.service_name)
                      ? `$${parseFloat(item.total_price || 0).toFixed(2)}`
                      : item.item_type === "Product"
                      ? `$${parseFloat(item.product_selling || 0).toFixed(2)}`
                      : `$${parseFloat(item.service_selling || 0).toFixed(2)}`}
                  </td>
                  <td>
                    {item.total_price
                      ? `$${parseFloat(item.total_price).toFixed(2)}`
                      : `$${(
                          item.quantity *
                          (item.item_type === "Product"
                            ? parseFloat(item.product_selling || 0)
                            : parseFloat(item.service_selling || 0))
                        ).toFixed(2)}`}
                  </td>
                  <td>{item.is_free ? (language === "ar" ? t("orderInvoice.yes") : "Yes") : (language === "ar" ? t("orderInvoice.no") : "No")}</td>
                </tr>
              ))}
              <tr>
                <td colSpan="5" className="text-right">
                  {language === "ar" ? t("orderInvoice.total") : "Total:"}
                </td>
                <td>{`$${total.toFixed(2)}`}</td>
              </tr>
              {discount > 0 && (
                <tr>
                  <td colSpan="5" className="text-right">
                    {language === "ar" ? t("orderInvoice.totalWithoutDiscount") : "Total without Discount:"}
                  </td>
                  <td>{`$${totalWithoutDiscount.toFixed(2)}`}</td>
                </tr>
              )}
              <tr>
                <td colSpan="5" className="text-right">
                  {language === "ar" ? t("orderInvoice.discount") : "Discount:"}
                </td>
                <td>
                  <input
                    type="number"
                    step="0.01"
                    min={0}
                    max={
                      Number.isFinite(total) ? total : Number.MAX_SAFE_INTEGER
                    }
                    value={discount}
                    onChange={handleDiscountChange}
                  />
                </td>
              </tr>
              <tr>
                <td colSpan="5" className="text-right">
                  {language === "ar" ? t("orderInvoice.totalWithDiscount") : "Total with Discount:"}
                </td>
                <td>{`$${totalWithDiscount.toFixed(2)}`}</td>
              </tr>
            </tbody>
          </table>
          {!hasShift && (
            <div className="alert alert-warning" role="alert">
              {language === "ar"
                ? t("orderInvoice.shiftRequired")
                : "An open shift is required to create an invoice."}
            </div>
          )}
          <div className="fo">
            <button
              type="submit"
              className="btn btn-primary btn-md"
              disabled={!hasShift || !selectedDrawer}
            >
              {language === "ar" ? t("orderInvoice.createInvoice") : "Create Invoice"}
            </button>
          </div>
        </form>
      </div>
      {message && (
        <div
          className={`alert alert-${message.type} alert-dismissible fade show`}
          role="alert"
          style={{
            position: "fixed",
            bottom: "10px",
            margin: "10px",
            right: "10px",
            zIndex: "9999",
          }}
        >
          {message.text}
        </div>
      )}
    </div>
  );
}

export default InvoiceOrder;
